import { TravelersState } from "stores/wizard/state/global/travelers";
import { InfantSeating } from "src/components/shared/TravelersField";

export const travelersState: TravelersState = {
  hotel: {
    rooms: [
      {
        adults: 1,
        children: [],
        infants: [],
      },
    ],
    infantSeating: InfantSeating.ON_LAP,
  },
  hotelPackage: {
    rooms: [
      {
        adults: 2,
        children: [],
        infants: [],
      },
    ],
    infantSeating: InfantSeating.ON_LAP,
  },
  nonHotel: {
    rooms: [
      {
        adults: 1,
        children: [],
        infants: [],
      },
    ],
    infantSeating: InfantSeating.ON_LAP,
  },
};
